import React from 'react'
import './Gallery1.css'

const Gallerysec1 = () => {
  return (
    <>
     {/* <div className='backgroundimg'>
        <img src='./hotel-surya-vilas-palace 1.png' className='imgh' alt='#'/>
        <div className='centred'>
            <p className='texts'>WEDDING GALLERY</p>
        </div>

    </div> */}

      
    </>
  )
}

export default Gallerysec1
